export default "__VITE_ASSET__DU9ftMZ7__"